import React, { useState, createContext, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './css/admin.css';
import { API } from "./services/api";
import axios from "axios";
import logo from './img/logo/ManeeCafeLogo.jpg';

import info from './img/icon/mainMenu/info.png';
import product from './img/icon/mainMenu/product.png';
import warehouse from './img/icon/mainMenu/warehouse.png';
import coffee from './img/icon/mainMenu/coffee.jpg';
import store_inventory from './img/icon/mainMenu/store_inventory.png';
import membership from './img/icon/mainMenu/membership.png';
import pos from './img/icon/mainMenu/pos.png';
import exit from './img/icon/mainMenu/exit.png';
import home from './img/icon/home.png';


import locationicon from './img/icon/basicinfoMenu/location.png';
import ruleicon from './img/icon/basicinfoMenu/ruleicon.png';
import statusicon from './img/icon/basicinfoMenu/statusicon.png';
import suppliericon from './img/icon/basicinfoMenu/suppliericon.png';
import employeeicon from './img/icon/basicinfoMenu/employeeicon.png';
import paytypeicon from './img/icon/basicinfoMenu/paytype.png';
import sizeicon from './img/icon/basicinfoMenu/sizeicon.png';


import producttypeicon from './img/icon/productMenu/producttypeicon.png';
import categoryicon from './img/icon/productMenu/categoryicon.png';
import brandicon from './img/icon/productMenu/brandicon.png';
import menuicon from './img/icon/productMenu/menuicon.png';
import submenu from './img/icon/productMenu/submenu.png';
import producticon from './img/icon/productMenu/producticon.png';
import reporticon from './img/icon/productMenu/reporticon.png';
import exchagneicon from './img/icon/productMenu/exchangeicon.png';
import ingredienticon from './img/icon/productMenu/ingredienticon.png';
import image_upload from './img/icon/productMenu/image_upload.png';


import purchasebillicon from './img/icon/warehouse/purchasebillicon.png';
import pendingbillicon from './img/icon/warehouse/pendingbillicon.png';
import orderbillicon from './img/icon/warehouse/orderbillicon.png';
import recivebillicon from './img/icon/warehouse/recivebillicon.png';
import storeOrdericon from './img/icon/warehouse/storeOrdericon.png';
import takeoutproducticon from './img/icon/warehouse/takeoutproducticon.png';
import takeoutbillicon from './img/icon/warehouse/takeoutbillicon.png';

import newMembericon from './img/icon/member/newMembericon.png';
import topupicon from './img/icon/member/topupicon.png';
import cancleicon from './img/icon/member/cancleicon.png'
import reporticon2 from './img/icon/member/reporticon.png'
import reportusecard from './img/icon/member/reportusecard.png'
import reportmemberbalance from './img/icon/member/reportmemberbalance.png'
import reportcancle from './img/icon/member/reportcancle.png'

import order from './img/icon/pos/order.png'
import taxreporticon from './img/icon/pos/taxreporticon.png'
import viewicon from './img/icon/pos/viewicon.png'

import backimg from './img/backimg.jpg';


// import components
// import NavbarComponent from './components/navbar';

// import pages


import PrinterComponent from './services/connectprinter';

import Login from './pages/Login';
// import admin page

import Employee from './pages/admin/basicInfo/employee';
import PaymentType from './pages/admin/basicInfo/paymentType';
import Currency from './pages/admin/basicInfo/currency';
import Location from './pages/admin/basicInfo/location';
import UserRole from './pages/admin/basicInfo/role';
import SizeType from './pages/admin/basicInfo/sizeType';
import Status from './pages/admin/basicInfo/status';
import TableNumber from './pages/admin/basicInfo/tableNumber';
import Supplier from './pages/admin/basicInfo/supplier';


// import product 
import ProductType from './pages/admin/product/productType';
import PromotionItemInfo from './pages/admin/product/promotionItemInfo';
import Category from './pages/admin/product/category';
import Brand from './pages/admin/product/brand';
import Product from './pages/admin/product/product';
import Menu from './pages/admin/product/menu';
import UploadIconMenu from './pages/admin/product/uploadIconMenu';
import SubMenu from './pages/admin/product/subMenu';
import UploadImage from './pages/admin/product/uploadimgProduct';
import ProductReport from './pages/admin/product/ProductReport';
import CreateIngredient from './pages/admin/product/createIngredient';

// import Stock
import PurchaseOrder from './pages/admin/stock/purchaseOrder';
import PendingBill from './pages/admin/stock/pendingBill';
import OrderBill from './pages/admin/stock/orderBill';
import ReceivedBill from './pages/admin/stock/receivedBill';
import InventoryReport from './pages/admin/stock/report/InventoryReport';
import StoreOrderPendingBill from './pages/admin/stock/store_order_pendingBill';
import Store_order_Order_ReciveBill from './pages/admin/stock/store_order_Order_ReciveBill';
import SaleProduct from './pages/admin/stock/SaleProduct';
import StockSaleProductReport from './pages/admin/stock/report/StockSaleProductReport';
import StockSaleProductCashReport from './pages/admin/stock/report/StockSaleProductCashReport';
import StoreOrderReport from './pages/admin/stock/report/StoreOrderReport';
import TakeOutProduct from './pages/admin/stock/TakeOutProduct';
import TakeOutProductBill from './pages/admin/stock/TakeOutProductBill';

// import Coffee
import Coffee from './pages/admin/product/Coffee';


// import Store Stock
import StorePurchaseOrder from './pages/admin/store_stock/store_purchaseOrder';
import StorePendingBill from './pages/admin/store_stock/store_pendingBill';
import StoreOrderBill from './pages/admin/store_stock/store_orderBill';
import StoreReceivedBill from './pages/admin/store_stock/store_receivedBill';
import StoreInventoryReport from './pages/admin/store_stock/report/store_inventoryReport';
import StoreTakeOutProduct from './pages/admin/store_stock/StoreTakeOutProduct';
import StoreTakeOutProductBill from './pages/admin/store_stock/StoreTakeOutProductBill';

// Import Member
import Member from './pages/admin/member/member';
import TopUpReport from './pages/admin/member/report/topupreport';
import BillReport from './pages/admin/member/report/BillReport';
import CancelTopUpBillReport from './pages/admin/member/report/CancelTopUpBillReport';
import MemberTransactionReport from './pages/admin/member/report/MemberTransactionReport';
import MemberPointReport from './pages/admin/member/report/MemberPointReport';


// Import Member
import RewardCard from './pages/admin/member/rewardCard';
import TopUp from './pages/admin/member/topup';
import CancelTopUpBill from './pages/admin/member/cancelTopUpBill';

//Import GiftCard 
import GiftCard from './pages/admin/member/giftCard';
import SellGiftCard from './pages/admin/member/sellgiftcard';


// import POS
import POS from './pages/admin/pos/pos';
import CancelBill from './pages/admin/pos/cancelBill';
import PromoItem from './pages/admin/pos/promoItem';
import TransactionReport from './pages/admin/pos/report/TransactionReport';
import CancelBillReport from './pages/admin/pos/report/CancelBillReport';
import CashReport from './pages/admin/pos/report/CashReport';
import SaleProductReport from './pages/admin/pos/report/SaleProductReport';
import TaxReport from './pages/admin/pos/report/TaxReport';
import ExchangeReport from './pages/admin/pos/report/ExchangeReport';
import EditOrder from './pages/admin/pos/editOrder';
import EditBillPayment from './pages/admin/pos/EditBillPayment';
import BillScreen from './pages/admin/pos/billScreen';

// import SummaryCashChart from './pages/admin/pos/report/SummaryCashChart';




// import RegisterTable from './pages/admin/pos/registertable';

import KitchenOrder from './pages/admin/pos/KitchenOrder';

// import customer page
import Customer_home from './pages/customer/customer_home';
import { Warehouse } from "lucide-react";

const UserContext = createContext();
const AlertContext = createContext();
const ProgressBarContext = createContext();

function App() {
  const [ShowProgressBar, setShowProgressBar] = useState(false);
  const [Progress, setProgress] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [login, setLogin] = useState(false);
  const [userID, setUserID] = useState();
  const [UserName, setUserName] = useState();
  const [LocationName, setLocationName] = useState();
  const [Role, setRole] = useState();
  const [LocationID, setLocationID] = useState();
  const [SubMenuList, setSubMenuList] = useState([]);
  const [KitchenList, setKitchenList] = useState();
  const [Address, setAddress] = useState();
  const [Tell, setTell] = useState();
  
  

  const [HeadTitle, setHeadTitle] = useState();
  const [showForm, setShowForm] = useState(false);
  const [popLink, setpopLink] = useState(false);

  const [showSubmenu, setshowSubmenu] = useState(false);
  const [showMainmenu, setshowMainmenu] = useState(true);

  useEffect(() => {
    let token = localStorage.getItem("token");
    let userData = localStorage.getItem("data");
    if (token) {
      let data = { token: `MR_ADMIN ${token}` };
      axios
        .post(`${API}/verify-token`, data).then((response) => {
          if (response?.status === 200) {
            setLogin(true);
            let userRole = JSON.parse(userData);
            setUserID(userRole.EmployeeID);
            setUserName(userRole.Name);
            setLocationName(userRole.LocationName);
            setRole(userRole.Role);
            setLocationID(userRole.LocationID)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  if (!login) {
    return <Login setLogin={setLogin} setshowMainmenu={setshowMainmenu} setTell={setTell} setAddress={setAddress} setUserID={setUserID} setLocationID={setLocationID} setLocationName={setLocationName} setUserName={setUserName} setRole={setRole} />;
  } 

  const navbarMenuList = [{id: 0,  value: 'ຂໍ້ມູນພື້ນຖ້ານ', icon :info}, 
                          {id: 1,  value: "ຂໍ້ມູນສິນຄ້າ", icon: product}, 
                          {id: 2,  value: "ຂໍ້ມູນສາງ", icon: warehouse}, 
                          // {id: 3,  value: "ຂໍ້ມູນກາເຟ", icon: coffee}, 
                          {id: 3,  value: "ຂໍ້ມູນສາງຮ້ານ", icon: store_inventory}, 
                          {id: 4,  value: "Member", icon: membership}, 
                          {id: 5,  value: "POS", icon: pos}, 
                          {id: 6,  value: "SignOut", icon: exit}];
  const sideBardMenuList = [
    [ {id: 1, value:'ສາຂາ', icon :locationicon, popLink: <Location/>}, 
      {id: 2, value: 'ສິດນຳໃຊ້', icon :ruleicon, popLink: <UserRole/>}, 
      {id: 3, value: 'ສະຖານະ', icon :statusicon, popLink: <Status/>}, 
      {id: 4, value: 'ຜູ້ສະໜອງ', icon :suppliericon, popLink: <Supplier/>}, 
      {id: 5, value: 'ພະນັກງານ', icon :employeeicon, popLink: <Employee/>}, 
      {id: 6, value: 'ປະເພດຈ່າຍ', icon :paytypeicon, popLink: <PaymentType/>}, 
      {id: 7, value: 'ປະເພດຂະໜາດ', icon :sizeicon, popLink: <SizeType/>}, 
      {id: 8, value: 'Home', icon :home}, 
    ],
    [ {id: 1, value: "ປະເພດສິນຄ້າ", icon :producttypeicon, popLink: <ProductType/>}, 
      {id: 2, value: "ໝວດສິນຄ້າ", icon :categoryicon, popLink: <Category/>}, 
      {id: 3, value: "ຫຍີ່ຫໍ້ສິນຄ້າ", icon :brandicon, popLink: <Brand/>}, 
      {id: 4, value: "ສ້າງເມນູຂາຍ", icon :menuicon, popLink: <Menu/>}, 
      {id: 4, value: "ເພີ່ມຮູບເມນູ", icon :image_upload, popLink: <UploadIconMenu/>}, 
      {id: 5, value: "ສ້າງເມນູຂາຍຍ່ອຍ", icon :submenu, popLink: <SubMenu/>}, 
      {id: 6, value: "ສ້າງຂໍ້ມູນສິນຄ້າ", icon :producticon, popLink: <Product/>}, 
      {id: 7, value:"ລາຍງານຂໍ້ມູນສິນຄ້າ", icon :reporticon, popLink: <ProductReport/>}, 
      {id: 8, value: "ສ້າງຂໍ້ມູນແລກສິນຄ້າ", icon :exchagneicon, popLink: <PromotionItemInfo/>}, 
      {id: 9, value: "ສ້າງສ່ວນພະສົມ", icon :ingredienticon, popLink: <CreateIngredient/>}, 
      {id: 10, value: "ເພີ່ມຮູບສິນຄ້າ", icon :image_upload, popLink: <UploadImage/>},
      {id: 11, value: 'Home', icon :home}, 
    ],
    [ {id: 1, value: 'ສ້າງໃບສັ່ງຊື້', icon :purchasebillicon, popLink: <PurchaseOrder/>}, 
      {id: 2, value: 'ບິນລໍຖ້າສັ່ງຊື້', icon :pendingbillicon, popLink: <PendingBill/>}, 
      {id: 3, value: 'ບິນທີ່ສັ່ງຊື້', icon :orderbillicon, popLink: <OrderBill/>}, 
      {id: 4, value: 'ບິນທີ່ຮັບເຄື່ອງເຂົ້າສາງ', icon :recivebillicon, popLink: <ReceivedBill/>}, 
      {id: 5, value: 'ລາຍງານຈຳນວນສິນຄ້າ', icon :reporticon, popLink: <InventoryReport/>}, 
      {id: 6, value: "ບິນຮ້ານເບີກເຄື່ອງ", icon :storeOrdericon, popLink: <StoreOrderPendingBill/>}, 
      {id: 7, value:"ບິນຮ້ານທີ່ຮັບເຄື່ອງ", icon :recivebillicon, popLink: <Store_order_Order_ReciveBill/>}, 
      {id: 8, value: "ນຳເຄື່ອງອອກສາງ", icon :takeoutproducticon, popLink: <TakeOutProduct/>}, 
      {id: 9, value: "ບິນນຳເຄື່ອງອອກສາງ", icon :takeoutbillicon, popLink: <TakeOutProductBill/>}, 
      {id: 10, value: "ລາຍງານຮ້ານເບີກເຄື່ອງ", icon :reporticon, popLink: <StoreOrderReport/>},
      {id: 11, value: 'Home', icon :home}, 
    ],
    // [ {id: 1, value: "ສ້າງເມັດກາເຟ", icon :info, popLink: <POS/>}, 
    //   {id: 2, value: "ພິມບິນ", icon :info, popLink: <PrinterComponent/>},
    //   {id: 3, value: 'Home', icon :home, popLink: <POS/>}, 
    // ],
    [ {id: 1, value: 'ສ້າງໃບເບີກເຄື່ອງ', icon :purchasebillicon, popLink: <StorePurchaseOrder/>}, 
      {id: 2, value: 'ບິນລໍຖ້າເບີກເຄື່ອງ', icon :pendingbillicon, popLink: <StorePendingBill/>}, 
      {id: 3, value: 'ບິນລໍຖ້າຮັບເຄື່ອງ', icon :orderbillicon, popLink: <StoreOrderBill/>}, 
      {id: 4, value: 'ບິນທີ່ຮັບເຄື່ອງເຂົ້າຮ້ານ', icon :recivebillicon, popLink: <StoreReceivedBill/>},
      {id: 5, value: "ນຳເຄື່ອງອອກສາງ", icon :takeoutproducticon, popLink: <StoreTakeOutProduct/>}, 
      {id: 6, value: 'ລາຍງານຈຳນວນສິນຄ້າ', icon :reporticon, popLink: <StoreInventoryReport/>}, 
      {id: 7, value: 'ລາຍງານນຳເຄື່ອງອອກສາງຮ້ານ', icon :takeoutbillicon, popLink: <StoreTakeOutProductBill/>},
      {id: 8, value: 'Home', icon :home}, 
    ],
    [ {id: 1, value: 'ສ້າງ Member', icon :newMembericon, popLink: <Member/>}, 
      {id: 2, value: 'ເຕີມບັດ Member', icon :topupicon, popLink: <TopUp/>}, 
      {id: 3, value: 'ຍົກເລີກບິນເຕີມບັດ', icon :cancleicon, popLink: <CancelTopUpBill/>}, 
      {id: 4, value: 'ລາຍງານເຕີມບັດ', icon :reporticon2, popLink: <TopUpReport/>}, 
      {id: 5, value: 'ລາຍງານບິນເຕີມບັດ', icon :reporticon, popLink: <BillReport/>}, 
      {id: 6, value: 'ລາຍງານບິນເຕີມບັດທີ່ຍົກເລີກ', icon :reportcancle, popLink: <CancelTopUpBillReport/>}, 
      {id: 7, value: 'ລາຍງານໃຊ້ບັດ', icon :reportusecard, popLink: <MemberTransactionReport/>}, 
      {id: 8, value: "ລາຍງານຍອດເຫຼືອບັດ", icon :reportmemberbalance, popLink: <MemberPointReport/>},
      {id: 9, value: 'Home', icon :home}, 
    ],
    [ {id: 1, value: 'ຂາຍເຄື່ອງ', icon :order, popLink: <POS/>}, 
      {id: 2, value: 'ຍົກເລີກບິນ', icon :cancleicon, popLink: <CancelBill/>}, 
      // {id: 3, value: "ແກ້ໄຂປະເພດຈ່າຍບິນ", icon :info, popLink: <POS/>}, 
      {id: 3, value: "ແລກເຄື່ອງ", icon :exchagneicon, popLink: <PromoItem/>}, 
      {id: 4, value: 'ລາຍງານບິນຂາຍ', icon :reporticon, popLink: <TransactionReport/>}, 
      {id: 5, value: 'ລາຍງານບິນຍົກເລີກ', icon :reportcancle, popLink: <CancelBillReport/>}, 
      {id: 6, value: 'ລາຍງານສະຫລຸບເງິນ', icon :reporticon2, popLink: <CashReport/>}, 
      // {id: 7, value: "ສະຫລຸບເງິນ", icon :recivebillicon, popLink: <SummaryCashChart/>}, 
      {id: 7, value: "ລາຍງານຂາຍສິນຄ້າ", icon :reportusecard, popLink: <SaleProductReport/>}, 
      {id: 8, value:'ລາຍງານອາກອນ', icon :taxreporticon, popLink: <TaxReport />}, 
      {id: 9, value: "ລາຍງານແລກເຄື່ອງ", icon :recivebillicon, popLink: <ExchangeReport/>}, 
      {id: 10, value: "ຈໍສະແດງບິນ", icon :viewicon, popLink: <BillScreen/>},
      // {id: 11, value: "ບິນຄົວ", icon :viewicon, popLink: <KitchenList/>},
      {id: 11, value: 'Home', icon :home}, 
    ]
  ];

  const handleClick = (id, value) => {
    if(value == 'Home'){
      setshowSubmenu(false);
      setshowMainmenu(true);
    } else {
      setHeadTitle(value);
      setshowSubmenu(true);
      setshowMainmenu(false);
      setSubMenuList(sideBardMenuList[id]);
      if(value === "SignOut"){
        signout();
        setHeadTitle("");
      } 
    };
    
  }

   const handleClickSubmenu = (id, value, popLink) => {
    if(value == 'Home'){
      setshowSubmenu(false);
      setshowMainmenu(true);
    } else {
      setHeadTitle(value);
      setshowSubmenu(false);
      setshowMainmenu(false);
      setShowForm(true);
      setpopLink(popLink);
    };
    
  }

  const signout = () => {
     localStorage.removeItem('data');
     localStorage.removeItem('userData');
     localStorage.removeItem('token');
     localStorage.removeItem('productData');
     localStorage.removeItem('paymentTypeData');
     localStorage.removeItem('productTypeData');
     localStorage.removeItem('categoryData');
     localStorage.removeItem('currencyData');
     localStorage.removeItem('brandData');
     localStorage.removeItem('sizeTypeData');
     localStorage.removeItem('supplierData');
     localStorage.removeItem('locationData');
     localStorage.removeItem('statusData');
     localStorage.removeItem('ProductTypeData');
     localStorage.removeItem('purchaseOrderData');
     localStorage.removeItem('roleData');
     localStorage.removeItem('tableNumberData');
     localStorage.removeItem('memberData');
     localStorage.removeItem('discountData');
     localStorage.removeItem('productBySubMenuData');
     localStorage.removeItem('rewardcardData');
     localStorage.removeItem('subMenuData');
     localStorage.removeItem('menuData');
     setLogin(false);
  };

  if(Role === "Admin" || Role ==="Cashier" || Role === "StoreStock"){
    return (
      <AlertContext.Provider value={{showAlert, setShowAlert, errorMessage, setErrorMessage}}>
        <UserContext.Provider value={{ UserName, userID, LocationID, Address, Tell, setTell, setAddress, setshowMainmenu, showForm, 
          KitchenList, LocationName, login, setshowSubmenu, setShowForm, setShowAlert, setErrorMessage, Role}}>
          <ProgressBarContext.Provider value={{ShowProgressBar, setShowProgressBar, Progress, setProgress}}>
            <div className="admin_container">
              <div className="content">
                { showMainmenu && (
                  <div className="mainMenu">
                    <div className="header">
                      <p>Manee Arabica Coffee</p>
                    </div>
                    {
                      navbarMenuList && navbarMenuList.map(item => {
                        if(Role =="Admin"){
                          return (
                            <div key={item.id} className="item" onClick={() => handleClick(item.id, item.value)} tabIndex={item.id}>
                                <div className="item-body">
                                    <div className="imgIcon">
                                        <img src={item.icon} className="iconimg" />
                                    </div>
                                    <div className="name">
                                        <p>{item.value}</p>
                                    </div>
                                </div>
                            </div>
                          )
                        } else {
                          if(item.id > 2){
                            return (
                              <div key={item.id} className="item" onClick={() => handleClick(item.id, item.value)} tabIndex={item.id}>
                                  <div className="item-body">
                                      <div className="imgIcon">
                                          <img src={item.icon} className="iconimg" />
                                      </div>
                                      <div className="name">
                                          <p>{item.value}</p>
                                      </div>
                                  </div>
                              </div>
                            )
                          }
                        }
                      })
                    }
                  </div>
                )}

                { showSubmenu && (
                  <div className="mainMenu">
                    <div className="header">
                      <p>{HeadTitle}</p>
                    </div>
                    {
                      SubMenuList && SubMenuList.map(item => {
                        return (
                              <div key={item.id} className="item" onClick={() => handleClickSubmenu(item.id, item.value, item.popLink)} tabIndex={item.id}>
                                  <div className="item-body">
                                      <div className="imgIcon">
                                          <img src={item.icon} className="iconimg" />
                                      </div>
                                      <div className="name">
                                          <p>{item.value}</p>
                                      </div>
                                  </div>
                              </div>
                          )
                      })
                    }
                  </div>
                )}
              </div>

              { showForm && (
                  <div className="mainForm">
                    <img className="logo" src={backimg} />
                      {popLink}
                  </div>
              )}
            </div>
            </ProgressBarContext.Provider>
        </UserContext.Provider>
      </AlertContext.Provider>
    );
  } else {
    return (
      <div>
        <UserContext.Provider value={{ UserName, userID, login}}>
          <Customer_home />
        </UserContext.Provider>
      </div>
        
    );
  }
}

export {AlertContext, UserContext, ProgressBarContext};
export default App;
